import { FC, RefObject, forwardRef } from 'react';

import { Box, GridItem, GridItemProps, Img, Text } from '@chakra-ui/react';
import { Booster } from 'models';

type BoosterCardProps = {
  booster: Booster;
  type?: 'spin' | 'default';
  cardWidth?: string | number;
  minCardHeight?: string | number;
  noShadow?: boolean;
} & GridItemProps;

const BoosterCard = forwardRef<HTMLDivElement, BoosterCardProps>(
  ({ booster, onClick, type = 'default', minCardHeight = '255px', noShadow, ...props }, ref) => {
    return (
      <GridItem ref={ref} {...props} zIndex="99" position="relative">
        <Box
          pos="relative"
          bgImage={`url(${booster.image})`}
          bgSize="cover"
          bgPos="center center"
          width={'100%'}
          minHeight={minCardHeight}
          aspectRatio={'1/1.5'}
          bgColor={booster.backgroundColor ?? 'white'}
          boxShadow={noShadow ? 'none' : '0px 6px 50px 0px #000000CC'}
          border="1px solid rgba(255,255,255,0.3)"
          borderRadius="16px"
          transition="opacity 0.2s linear"
          onClick={onClick}
          overflow="hidden"
        >
          <Text
            color={booster.textColor ?? undefined}
            variant="boosterName"
            pos="absolute"
            top="12px"
            left="12px"
            right="12px"
          >
            {`${booster.rarity} ${booster.league}`}
          </Text>
          <Text
            variant="boosterMultiplier"
            pos="absolute"
            bottom="16px"
            left="12px"
            right="12px"
            zIndex="100"
            color={booster.textColor ?? undefined}
          >
            <Text
              lineHeight="1.2"
              p="2px 6px"
              fontSize="14px"
              fontWeight="400"
              bgColor={booster.backgroundColor ?? undefined}
              borderRadius="4px"
              as="span"
              border="1px solid rgba(0,0,0,0.05)"
            >
              {booster.attributeMultiplier} x {booster.attributeDisplay?.toUpperCase()}
            </Text>
            <br />
          </Text>
          {booster.icon && (
            <Img
              src={booster.icon}
              pos="absolute"
              top="0"
              left="0"
              w="100%"
              h="100%"
              objectFit="contain"
              objectPosition="center"
            />
          )}
        </Box>
      </GridItem>
    );
  }
);

BoosterCard.displayName = 'BoosterCard';

export default BoosterCard;
